/* eslint-disable no-dupe-keys */
import React from "react";
import Spinner from 'react-bootstrap/Spinner';
import bg from "../img/bg.png";
export default function LoadingPage() {
    return (
        <> <div>
            <section
                style={{
                    backgroundImage: `url(${bg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100% 100%",
                    backgroundSize: "cover",
                    minHeight: "1180px"
                }}
            >
                <div className="container min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="row justify-content-center" >
                        <div className="col-xl-5 col-lg-6 col-md-10 d-flex flex-column align-items-center justify-content-center">
                            <div className="mb-3">
                                <div className="card-body" >
                                    <div className="d-flex row pt-4 pb-2 text-center  " >
                                        <div style={{ color: "white", backgroundColor: "none" }} disabled >

                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="lg"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: "5rem", height: "5rem" }}
                                            />

                                            <span className="visually-hidden">Loading...</span>
                                        </div>{' '}
                                        <div className="text-center" style={{ fontSize: "25px", color: "#71747D", fontWeight: "600" }}>Loading...</div>
                                    </div>
                                </div>  </div>

                        </div>
                    </div>
                </div>

            </section >
        </div>
        </>
    );
}
